import React, { useEffect, useState } from 'react';
import Services from '../services';
import { PrismicService } from '../services/prismic';
import NavbarHeader from '../components/NavbarHeader';
import NavBarMenu from '../components/NavBarMenu';
import ContentSections from '../components/ContentSections/ContentSections';
import Footer from '../components/Footer';
import SALESFORCE from '../services/salesforce';
import { SALESFORCE_PRODUCT } from '../services/utils/salesforce-products';
import { validation } from './Hogar/validaton';
import { PROSPECTO } from '../services/prospecto';
import { TipoAsegurado } from '../services/utils/tipo-asegurado';
import { DATALAYERS } from '../services/datalayers';
import TermsAndConditionsModal from '../components/TermsAndConditionsModal';
import { environment } from '../environments/environment';
import { Helmet } from 'react-helmet';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { getMaestro } from '../services/maestro';
import { replaceKeyByMap } from "../services/replace-key-by-map";
import { SalesforceStrCual } from "../services/utils/salesforce-str-cual";
import { TipoDocumentoSalesforce } from "../services/utils/TipoDocumentoSalesforce"

const SeguroHogar = ({ tenantName }) => {

  useEffect(() => {
    DATALAYERS.pushObject({
      'name': 'pv-exequias',
      'source': 'suraenlinea',
      'event': 'pageview-virtual'
    });
  }, []);
  const [contactSection, setContactSection] = useState({
    contactSections: [],
    contactData: [],
    loadingContact: true,
  });

  const [menu, setMenu] = useState([]);
  const [maestroState, setMaestroState] = useState({
    maestro: []
  });
  const [sections, setSections] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showTCModal, setShowTCModal] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getMapMaestro = () => {
    const keysMap = {
      codigo: 'key',
      short_name: 'value'
    };
    const { maestro } = maestroState;
    return replaceKeyByMap(keysMap, maestro);
  }

  const getTipoDocumentoSalesforceBySigla = (sigla) => {
    const siglaTipoDocumentoSalesforce = Object.keys(
      TipoDocumentoSalesforce
    ).find(keyTipoDocumentoSalesforce => keyTipoDocumentoSalesforce === sigla);
    return siglaTipoDocumentoSalesforce ? TipoDocumentoSalesforce[siglaTipoDocumentoSalesforce] : maestroState.maestro.find((maestro) => maestro.codigo === sigla).short_name.toUpperCase()
  }

  const fields = [
    { label: 'Nombres', type: 'text', name: 'firstName', value: '', maxlength: 50 },
    { label: 'Apellidos', type: 'text', name: 'lastName', value: '', maxlength: 50 },
    { label: 'Tipo de identificación', type: 'select', name: 'typeId', value: '', maxlength: 50, data: getMapMaestro() },
    { label: 'Número de identificación', type: 'text', name: 'document', value: '', maxlength: 10 },
    { label: 'Correo electrónico', type: 'text', name: 'email', value: '', maxlength: 50 },
    { label: 'Celular', type: 'text', name: 'phone', value: '', maxlength: 10 },
    {
      label: 'Autorizo el uso responsable de mi información y acepto términos y condiciones',
      type: 'checkbox',
      name: 'authorization',
      value: '',
      onClick: () => setShowTCModal(true),
    },
  ];

  const onBannerFormSubmit = (values, resetForm) => {
    const tenant = tenantName && environment.tenants.find(t => t.tenant === tenantName);
    executeRecaptcha("cotizarSeguroExequias").then((token) => {
      PROSPECTO.saveProspecto({
        seguros: [{
          producto: { nombre: 'SeguroExequias' },
        }],
        datosAsesor: {
          codigoCanal: tenant && tenant.codigoCanal,
          codigoAsesor: tenant && tenant.codigoAsesor,
        },
        aceptos: [{
          tipo: 'Datos personales',
          nombre: 'Tratamiento de datos SeguroExequias'
        }],
        trazabilidad: {
          origen: document.location.origin,
          tenant: tenantName,
          url: document.location.href,
        },
        fechaCreacion: new Date().valueOf(),
        tomador: {
          persona:
          {
            PersonaNaturalTemp: {
              primerNombre: values.firstName.split(' ')[0],
              segundoNombre: values.firstName.split(' ')[1],
              primerApellido: values.lastName.split(' ')[0],
              segundoApellido: values.lastName.split(' ')[1],
              correo: values.email,
              celular: values.phone.toString(),
              numeroIdentificacion: values.document,
              tipoIdentificacion: values.typeId,
            }
          },
          tipoAsegurado: TipoAsegurado.ASEGURADO_PRINCIPAL,
        },
      }, token)
    });


    const camposAdicionales = {
      'Solucion_de_interes__c': 'Exequias',
    };

    SALESFORCE.sendTomadorDataToSalesForce(
      values.firstName,
      values.lastName,
      values.phone,
      getTipoDocumentoSalesforceBySigla(values.typeId),
      values.document,
      values.email,
      SALESFORCE_PRODUCT.EXEQUIAS,
      SalesforceStrCual.FORMULARIO_COMPRA,
      camposAdicionales
    )
      .finally(() => {
        resetForm();
      });
    DATALAYERS.push('Lead', 'Exequias-Asesoría');
  };

  useEffect(() => {
    PrismicService.getDocument('landing', [tenantName, 'seguro-exequias'])
      .then(response => {
        setSections(response.results[0].data.sections);
        setData(response.results[0].data);
        setLoading(false);
      }
      );

    PrismicService.getDocument("contacto", [tenantName]).then(response => {
      setContactSection({
        contactData: response.results[0].data,
        contactSections: response.results[0].data.sections,
        loadingContact: false,
      });
    });

    getMaestro('mst_tipo_documento', 'landings').then(response => {
      const orderedRes = response.sort((a, b) => {
        const x = a.codigo;
        const y = b.codigo;
        if (x < y) { return -1 }
        if (x > y) { return 1 }
      });
      setMaestroState({
        maestro: orderedRes
      });
    });
  }, []);

  useEffect(() => {
    Services.COMMONS.MENUS.get(tenantName).then(menuPrismic => setMenu(menuPrismic));
  }, []);

  const { contactSections, contactData, loadingContact } = contactSection;

  return (
    <React.Fragment>
      <Helmet>
        <title>Seguro Exequial SURA / suraenlinea.com</title>
        <meta name="description" content="Cotiza y compra aquí el Seguro Exequial que te respalda a ti y tus seres queridos con gastos funerarios y la asesoría necesaria en caso de un fallecimiento." />
        <meta name="keywords" content="seguro exequial, funeraria, servicios funerarios, gastos funerarios, planes exequiales" />
      </Helmet>
      <NavbarHeader />
      {menu && <NavBarMenu menus={menu} />}
      {
        !loading ?
          <ContentSections
            sections={sections}
            data={data}
            fields={fields}
            validation={validation}
            onSubmit={onBannerFormSubmit}
          />
          : <p>Loading...</p>
      }
      {!loadingContact && <ContentSections
        sections={contactSections}
        data={contactData}
      />}
      <Footer />
      <TermsAndConditionsModal
        show={showTCModal}
        onDismiss={() => setShowTCModal(false)}
        prismicTags={['seguro-exequias']}>
      </TermsAndConditionsModal>
    </React.Fragment>
  );
}


export default SeguroHogar;
